// 2027年度改定の移行期だけオーナー系・Stay Gift from Owners に出す注記。どちらも ja 専用ルートからしか予約できないので翻訳しない。
// forBiz の移行が終わる 2028/5 宿泊以降に削除する
export function ClassAdditionalFeeIntegrationNote({
  appliesFrom,
}: {
  appliesFrom: string;
}) {
  return (
    <>
      <br />
      <span className="text-skogecha-60">
        {`※${appliesFrom}以降の宿泊については、クラス追加料金に統合されます`}
      </span>
    </>
  );
}
